import React from 'react'
import { useDndScrolling } from 'react-dnd-scrolling'
import Item from './Item'

export default function Layout({
  containerRef,
  onMove,
  onDrop,
  itemType,
  list,
  containerClassName,
  className,
  ...props
}) {
  if (containerRef) {
    useDndScrolling(containerRef)
  }

  return (
    <div ref={containerRef} className={containerClassName} {...props}>
      {list.map(({ id, index, editable, children }) =>
        editable ? (
          <Item
            key={id}
            id={id}
            index={index}
            onMove={onMove}
            onDrop={onDrop}
            className={className}
            itemType={itemType}
          >
            {children}
          </Item>
        ) : (
          children
        )
      )}
    </div>
  )
}
